import blue1 from '../../assets/icons/baby/blue1.svg';
import blue2 from '../../assets/icons/baby/blue2.svg';
import blue3 from '../../assets/icons/baby/blue3.svg';
import blue4 from '../../assets/icons/baby/blue4.svg';

import green1 from '../../assets/icons/baby/green1.svg';
import green2 from '../../assets/icons/baby/green2.svg';
import green3 from '../../assets/icons/baby/green3.svg';
import green4 from '../../assets/icons/baby/green4.svg';

import red1 from '../../assets/icons/baby/red1.svg';
import red2 from '../../assets/icons/baby/red2.svg';
import red3 from '../../assets/icons/baby/red3.svg';
import red4 from '../../assets/icons/baby/red4.svg';

import noBaby from '../../assets/icons/baby/blue1.svg'; // TODO: Replace with grey "?" baby

export default {
  blue1,
  blue2,
  blue3,
  blue4,
  green1,
  green2,
  green3,
  green4,
  red1,
  red2,
  red3,
  red4,
  noBaby
};



// WEBPACK FOOTER //
// ./src/components/icons/babyIcons.js